<script lang="ts">
  import type { ItemType } from '../../backend';
  import { getItemStats } from '../../items';
  import Stats from './Stats.svelte';

  export let boots: Extract<ItemType, { Boots: any }>['Boots'];
  export let extra: string | null;

  $: stats = getItemStats(boots.modifiers);
</script>

{#if boots.modifiers.length > 0}
  <h2 class="font-black mb-2 text-xl">Improved Boots</h2>
  <p class="text-white/80">
    Increases movement speed by {boots.speed.toFixed(
      0
    )}{#if stats.moveSpeed !== 0}
      <span class="text-white font-bold">+{stats.moveSpeed.toFixed(0)}</span>
    {/if}
    points.
  </p>
  <div class="mt-4 space-y-1">
    <Stats {stats} />
  </div>

  {#if extra}
    <p class="text-white/80 text-sm mt-4">
      {extra}
    </p>
  {/if}
{:else}
  <h2 class="font-black mb-2 text-xl">Boots</h2>
  <p class="text-white/80">
    Increases movement speed by {(boots.speed * 100).toFixed(0)} points.
  </p>
  {#if extra}
    <p class="text-white/80 text-sm mt-4">
      {extra}
    </p>
  {/if}
{/if}
